// src/router/index.js

import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import AuthLayout from "@/components/layouts/AuthLayout.vue";
import MainLayout from "@/components/layouts/MainLayout.vue";
import LoginPage from "@/views/LoginPage.vue";
// import RegisterPage from '@/views/RegisterPage.vue';
// import ForgotPasswordPage from '@/views/ForgotPasswordPage.vue';
import DashboardPage from "@/views/auth/DashboardPage.vue";
import UserPage from "@/views/auth/UserPage.vue";

import FormScreening from "@/components/FormScreening.vue";
import PatientList from "@/views/auth/PatientList.vue";

const routes = [
  {
    path: "/auth",
    component: AuthLayout,
    children: [
      {
        path: "login",
        name: "Login",
        component: LoginPage,
        meta: {
          guestOnly: true,
          title: "เข้าสู่ระบบ",
        },
      },
      // {
      //   path: 'register',
      //   name: 'Register',
      //   component: RegisterPage,
      //   meta: {
      //     guestOnly: true,
      //     title: 'ลงทะเบียน'
      //   }
      // },
      // {
      //   path: 'forgot-password',
      //   name: 'ForgotPassword',
      //   component: ForgotPasswordPage,
      //   meta: {
      //     guestOnly: true,
      //     title: 'ลืมรหัสผ่าน'
      //   }
      // },
      // {
      //   path: "reserve",
      //   name: "Reserve",
      //   component: () => import("@/views/ReservePage.vue"),
      //   meta: {
      //     guestOnly: true,
      //     title: "จองห้องพิเศษ",
      //   },
      // },
      // {
      //   path: "check-status",
      //   name: "CheckStatus",
      //   component: () => import("@/views/CheckStatusPage.vue"),
      //   meta: {
      //     guestOnly: true,
      //     title: "ตรวจสอบสถานะการจอง",
      //   },
      // },
      {
        path: "",
        name: "MainPage",
        component: () => import("@/views/MainPage.vue"),
        meta: {
          guestOnly: true,
          title: "หน้าหลัก",
        },
      },
    ],
  },
  {
    path: "/",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "Dashboard",
        component: DashboardPage,
        meta: {
          requiresAuth: true,
          title: "หน้าหลัก",
        },
      },
      {
        path: "profile",
        name: "Users",
        component: UserPage,
        meta: {
          requiresAuth: true,
          title: "โปรไฟล์ผู้ใช้",
        },
      },
      // {
      //   path: 'users',
      //   name: 'UserManagement',
      //   component: UserManagementPage,
      //   meta: {
      //     requiresAuth: true,
      //     requiresAdmin: true,
      //     title: 'จัดการผู้ใช้'
      //   }
      // },
      // {
      //   path: 'roles',
      //   name: 'RoleManagement',
      //   component: RoleManagementPage,
      //   meta: {
      //     requiresAuth: true,
      //     requiresAdmin: true,
      //     title: 'จัดการสิทธิ์'
      //   }
      // },
      // reservation-list
      {
        path: "screening",
        name: "Screening",
        component: FormScreening,
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
          title: "APACHE II Score ",
        },
      },
      {
        path: "patient-list",
        name: "PatientList",
        component: PatientList,
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
          title: "รายชื่อผู้ป่วย",
        },
      },
    ],
  },
  {
    path: "/:catchAll(.*)",
    redirect: { name: "Login" },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Navigation Guard to handle authentication
router.beforeEach(async (to, from, next) => {
  document.title = `${to.meta.title} | ${process.env.VUE_APP_NAME_EN}`;

  const isAuthenticated = store.getters.isAuthenticated;
  const currentUser = store.getters.currentUser;

  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: "Login" });
  } else if (to.meta.guestOnly && isAuthenticated) {
    next({ name: "Dashboard" });
  } else if (to.meta.requiresAdmin) {
    if (currentUser && ["admin", "owner", "user"].includes(currentUser.role)) {
      next();
    } else {
      next({ name: "Dashboard" });
    }
  } else {
    next();
  }
});

export default router;
